// extracted by mini-css-extract-plugin
export default {"md":"mdViewer_md__7+vso","short":"mdViewer_short__jBMND","hljs":"mdViewer_hljs__V4H7K"};